import React from 'react';
import {Link} from 'react-router-dom';

import './Logo.scss';

const Logo = ({extraClassName}) => {
  return (
    <div className={`logo ${extraClassName ? extraClassName : ''}`}>
      <Link to="/">
        <svg
          width="96"
          height="38"
          viewBox="0 0 96 38"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M91.42 29.2339V13.5778H91.1994L82.0799 29.2339H75.2408V8.76607H79.8208V24.4232H80.0201L89.1598 8.76607H96V29.2339H91.42ZM66.3782 29.2339L56.0992 19.1638V29.2339H51.5192V8.76607H56.0992V18.6329L65.758 8.76607H71.3781L61.4583 18.8372L72.1176 29.2339H66.3782ZM36.1251 36.0233C34.825 37.348 33.2447 38 31.3447 38C30.4646 38 29.3446 37.8378 28.8448 37.6745L28.4452 37.5924V33.332C29.1251 33.5969 29.9648 33.7397 30.9451 33.7397C32.6043 33.7397 33.8649 32.6594 34.7046 30.4774L34.8645 30.0698L25.3656 8.76607H30.2845L37.0842 24.3411H37.2845L43.3446 8.76607H48.304L39.5042 30.4774C38.5441 32.8422 37.4241 34.6977 36.1251 36.0233ZM5.06158 21.0203V26.4481H5.07979V29.2339H0V0H5.06158V0.006161H23.2187V0.424082V4.31989V16.7066V21.0203H18.1672H5.06158ZM18.1672 4.31989H5.06158V16.7066H18.1672V4.31989Z"
            fill="currentColor"
          />
        </svg>
      </Link>
    </div>
  );
};

export default Logo;
